// src/components/admin/admin-assign-direct.js

import React, { useState } from 'react';
import { RestHelper } from '../../helper/restHelper';
import RonBadge, { isRon } from '../ron-badge';

const AdminAssignDirect = (data) => {

    const [notaryList, setNotaryList] = useState([])
    const [notaryCount, setNotaryCount] = useState('')
    const [notaryLastName, setNotaryLastName] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [searchForm, setSearchForm] = useState(true)
    const [showResults, setShowResults] = useState(false)
    const [selectedValue, setSelectedValue] = useState('')
    const [selectedNotary, setSelectedNotary] = useState('')
    const [responseMessage, setResponseMessage] = useState()
    const [showResponseMessage, setShowResponseMessage] = useState(false)
    // RON orders default to listing RON-certified agents only
    const [ronOnly, setRonOnly] = useState(!!data.apptRon)

    const api = RestHelper()

    const findNotary = () => {
        const options = {}
        const reqData = { 'action': 'find', 'filter': notaryLastName, 'ronOnly': ronOnly }
        api
            .postCreate('/manage-users-admin', options, reqData)
            .then(res => setNotaryResults(res))
            .catch(err => console.log(err))
    }

    const assignNotary = () => {
        setIsLoading(true)
        setShowResults(false)
        const options = {}
        const reqData = { 'action': 'assignNotary', 'newNotary': selectedNotary, 'request_id': data.requestId }
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => setResponse(res))
            .catch(err => console.log(err))
    }

    const setResponse = (res) => {
        setResponseMessage(res['message'])
        setIsLoading(false)
        setShowResponseMessage(true)
    }

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setNotaryLastName(value)
    }

    const onSubmitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true)
        setSearchForm(false)
        findNotary()
    }

    const setNotaryResults = (res) => {
        setNotaryList(res['notaryList'])
        setNotaryCount(res['notaryCount'])
        setIsLoading(false)
        setShowResults(true)
    }

    function searchAgain() {
        setNotaryLastName('')
        setShowResults(false)
        setSearchForm(true)
    }

    function handleSelect(evt) {
        setSelectedValue(evt)
        setSelectedNotary(evt.email)
    }

    return (
        <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
            <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                <h2 className="text-lg font-semibold text-neutral-800">Direct Agent Assignment</h2>
                <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
            </div>
            <div className="p-4 sm:p-6">
                {searchForm && (
                    <form onSubmit={onSubmitHandler}>
                        <div className="mb-4">
                            <label htmlFor="notary" className="block text-sm font-medium text-neutral-700 mb-2">
                                Enter Signing Agent Last Name to Search:{ronOnly && <span className="font-normal text-neutral-500"> (optional with RON only)</span>}
                            </label>
                            <input
                                className="w-full sm:w-80 px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                id="notary"
                                onChange={(e) => onChangeEvent(e)}
                                type="text"
                                value={notaryLastName}
                                required={!ronOnly}
                            />
                        </div>
                        <label className="flex items-center gap-2 mb-4 cursor-pointer">
                            <input
                                className="h-4 w-4 text-blue-600 border-neutral-300 rounded focus:ring-blue-500"
                                type="checkbox"
                                checked={ronOnly}
                                onChange={(e) => setRonOnly(e.target.checked)}
                            />
                            <span className="text-sm font-medium text-neutral-700">RON certified agents only</span>
                        </label>
                        <button
                            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                            type="submit"
                        >
                            Search
                        </button>
                    </form>
                )}

                {showResults && (
                    <div>
                        <div className="mb-4 text-neutral-700">
                            <span className="font-medium">Signing Agent Name:</span> {notaryLastName || 'All'}{ronOnly && ' (RON only)'} | <span className="font-medium">Found Agents:</span> {notaryCount}
                        </div>
                        <div className="border border-neutral-200 rounded-lg overflow-hidden mb-4">
                            <div className="max-h-52 overflow-y-auto">
                                <table className="w-full text-sm">
                                    <thead className="bg-neutral-50 border-b border-neutral-200 sticky top-0">
                                        <tr>
                                            <th className="px-4 py-3 text-left font-semibold text-neutral-700">Agent Name</th>
                                            <th className="px-4 py-3 text-left font-semibold text-neutral-700">Location</th>
                                            <th className="px-4 py-3 text-left font-semibold text-neutral-700">Phone</th>
                                            <th className="px-4 py-3 text-left font-semibold text-neutral-700">Email</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-neutral-100">
                                        {notaryList.map((items) => (
                                            <tr
                                                key={items.email}
                                                className={`cursor-pointer transition-colors ${selectedValue === items ? 'bg-blue-100' : 'hover:bg-neutral-50'}`}
                                                onClick={() => handleSelect(items)}
                                            >
                                                <td className="px-4 py-3 text-neutral-800">{items.firstName} {items.lastName}{isRon(items.ronCertified) && <RonBadge className="ml-2" />}</td>
                                                <td className="px-4 py-3 text-neutral-600">{items.city}, {items.notaryState}</td>
                                                <td className="px-4 py-3 text-neutral-600">{items.mobilePhone}</td>
                                                <td className="px-4 py-3 text-neutral-600">{items.email}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {data.apptRon && selectedValue && !isRon(selectedValue.ronCertified) && (
                            <div className="bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded-lg mb-4 text-sm">
                                This is a RON order and the selected agent is not RON certified.
                            </div>
                        )}
                        <div className="flex flex-wrap gap-3">
                            <button
                                className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-medium py-2 px-4 rounded-lg border border-neutral-300 transition-colors"
                                type="button"
                                onClick={() => searchAgain()}
                            >
                                Search Again
                            </button>
                            <button
                                className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                type="button"
                                onClick={() => assignNotary()}
                                disabled={!selectedNotary}
                            >
                                Assign
                            </button>
                        </div>
                    </div>
                )}

                {isLoading && (
                    <div className="flex justify-center my-4">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    </div>
                )}

                {showResponseMessage && (
                    <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mt-4">
                        {responseMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminAssignDirect;
